import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import Contact from "./pages/contact";
import HeaderComponent from "./pages/header";
import Footer from "./pages/footer";
import ScrollToTop from "./scrollToTop";
import About from "./pages/about";
import Services from "./pages/services";
import Portfolio from "./pages/portfolio";
import Experience from "./pages/experience";
import SmoothScroll from "./components/scrool-animation";

const RoutesComponent = () => {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <HeaderComponent />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/project" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default RoutesComponent;
